import * as React from "react";
const SvgAlignVerticalBottom = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z",
  fill: "currentColor"
}));
export default SvgAlignVerticalBottom;